import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { SERVICES_TO_REGIONS } from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import MatchlistModel from "@/game-lol/models/lol-match-list.mjs";
import { getDerivedId } from "@/game-lol/utils/util.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getMatchList({ region, puuid }) {
  if (!region || !SERVICES_TO_REGIONS[region.toLowerCase()]) return null;
  if (!puuid) return null;

  return queryGQL(appURLs.RIOT, GraphQLTemplates.LeagueMatchlist, {
    region: region.toUpperCase(),
    puuid,
  });
}

export default function ({
  region,
  puuid,
  gameName,
  tagLine,
  options = {},
}: {
  region: string;
  puuid: string;
  gameName: string;
  tagLine: string;
  options: object;
}) {
  return getData(
    getMatchList({ region, puuid }),
    MatchlistModel,
    ["lol", "matchlists", getDerivedId(region, null, gameName, tagLine)],
    {
      ...options,
    },
  );
}
